export default {
  "cycleProFeature": {
    "title": "Tính năng chu trình chuyên nghiệp",
    "description": "Bạn có thể sử dụng tính năng này hoặc các tính năng hoàn chỉnh khác bằng cách kích hoạt Pro Cycle.",
    "more": "Tìm hiểu thêm"
  },
  "dateTimeFilter": {
    "dateAfter": "Ngày sau",
    "dateBefore": "Ngày trước",
    "time": "Thời gian",

    "all": "Tất cả",
    "am": "AM",
    "pm": "PM",

    "apply": "Áp Dụng",
    "reset": "Cài Đặt Lại",
  },
  "multipleImageInput": {
    "camera": "Máy ảnh",
    "image": "Phòng trưng bày"
  },
  "onboardNewFeatureModal": {
    "showFeature": "Hiển thị tính năng",
    "skipFeature": "đóng",
    "newFeature": "Tính năng mới",
    "titleFeature1": "Giám sát chi phí",
    "textFeature1": "Theo dõi ước tính chi phí hoạt động hàng ngày như một giải pháp thay thế cho việc đánh giá lãi/lỗ tiềm ẩn.",
    "titleFeature2": "Biểu đồ chi phí hoạt động",
    "textFeature2": "Hiển thị đồ họa ước tính để giúp dễ dàng xem được lãi/lỗ tiềm năng cho đến cuối chu kỳ.",
    "contentOverview": "Vuốt khu vực này để xem giá trị của chi phí/hoạt động trang trại.",
    "contentItemOverview": "Chọn một hộp để xem chi tiết cho mỗi nhóm.",
    "contentTabOverview": "Bạn có thể xem các thông tin khác nhanh hơn thông qua các tab.",
    "contentGraphOverview": "Bạn cũng có thể thấy xu hướng chi phí trong menu biểu đồ.",
    "contentTabGraphOverview": "Mới!\nBiểu đồ theo dõi chi phí.",
    "contentItemGraphOverview": "Đọc chi phí ước tính thông qua biểu đồ, bạn cũng có thể cuộn xuống để xem các biểu đồ khác.",
    "contentFilterGraphOverview": "Xem nhiều biểu đồ nhanh hơn thông qua bộ lọc này.",
  },
  "onboardModal": {
    "welcomeTitle": "Chào mừng đến với JALA",
    "welcomeDescription": "Làm theo hướng dẫn để bắt đầu hành trình tu luyện của bạn",
    "welcomeAction": "Làm Theo Hướng Dẫn",
    "welcomeSkipAction": "Bỏ qua bây giờ",
    "welcomeBanner": "Nếu bạn là nông dân, chuyển sang chế độ canh tác",
    "welcomeMenuOther": "Khám phá các dịch vụ khác để tìm hiểu về canh tác và trải nghiệm mô phỏng canh tác.",
    "welcomeOverview": "Giám sát tất cả dữ liệu chính của ao cá của bạn ở đây.",
    "welcomeOverviewCreateSomething": "Bắt đầu hành trình nuôi trồng của bạn bằng cách tạo %{something}",
    "welcomeMenu": "Khám phá các dịch vụ khác sẽ hỗ trợ bạn trong hành trình nuôi trồng của mình.",
    "welcomeHome": "",
    "welcomeQuickInput": "Nhập dữ liệu nuôi trồng của bạn ở đây.",
    "welcomeActivity": "Quản lý các hoạt động hàng ngày mà không sợ bỏ lỡ.",
    "welcomeMonitoring": "Phân tích ao của bạn tại đây.",

    "consultationTitle": "Bây giờ bạn có thể tham khảo về Trại Tôm",
    "consultationDescription": "Gặp vấn đề trong việc trồng trọt? tham khảo ý kiến một chuyên gia Jala cho vấn đề của bạn.",

    "newMenuTitle": "Mới! Đầu vào hoạt động hàng ngày",
    "newMenuSubtitle": "Như một lời nhắc nhở trong việc ghi lại tu luyện mỗi ngày"
  },
  "offlineMode": {
    "resetRequireInternet": "Đặt lại yêu cầu kết nối internet",
  },
  "shrimpPriceFilter": {
    "country": "Quốc Gia",
    "region": "Tỉnh",
    "time": "Cập Nhật Giá",
    "supplier": "Nhà Cung Cấp",

    "regionLabel": "Chọn Tỉnh",
    "timeLabel": "Chọn Cập Nhật Giá",
    "now": "Muộn nhất",
    "week": "> 1 Tuần",
    "month": "> 1 Tháng",

    "all": "Tất Cả",
    "verified": "Đã Xác Minh",

    "apply": "Áp Dụng",
    "reset": "Cài Đặt Lại",
  },
  "listEmpty": {
    "text": "Chưa có dữ liệu nào được lưu"
  },
  "listNetworkError": {
    "refreshPage": "Làm Mới Trang"
  },

  "astoCoachmark": {
    "connection": "Đèn báo Asto đã được kết nối Bluetooth hoặc Wifi hay chưa",
    "resetButton": "Đặt lại để đưa các thay đổi về trạng thái ban đầu",
    "saveButton": "Bạn có thể sử dụng tính năng 'Lưu' trước khi tải lên",
    "uploadButton": "Tải lên dữ liệu mà bạn đã nhập",
    "feedTable": "Bạn có thể sử dụng dữ liệu đã được nhập trong tính năng nhập nguồn cấp dữ liệu",
    "todayFeed": "Nhập tổng lượng ăn trong ngày",
    "todayFeedNormal": "Điều chỉnh khẩu phần theo giờ cho ăn trong ao",
    "nextDayFeed": "Bạn cũng có thể thêm dữ liệu nguồn cấp dữ liệu trong một tuần",
  }
}
